module.exports = __webpack_public_path__ + "img/Asset 69.49f8c1be.webp";